var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"card-c",staticStyle:{"display":"flex","height":"100%","flex-direction":"column"},attrs:{"title":"比例仪表盘"}},[_c('div',{staticClass:"card"},[_c('div',{ref:"c1",staticClass:"echart"}),_c('div',{ref:"c2",staticClass:"echart"}),_c('div',{ref:"c3",staticClass:"echart"}),_c('div',{ref:"c4",staticClass:"echart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }